// extracted by mini-css-extract-plugin
export default {"wrapper":"Popover_wrapper__EC3Ae","bodyList":"Popover_bodyList__YK219"};